import { render, staticRenderFns } from "./navigate-left-change.vue?vue&type=template&id=551e52fd&scoped=true&"
import script from "./navigate-left-change.vue?vue&type=script&lang=js&"
export * from "./navigate-left-change.vue?vue&type=script&lang=js&"
import style0 from "./navigate-left-change.vue?vue&type=style&index=0&id=551e52fd&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551e52fd",
  null
  
)

export default component.exports